import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Default styles
import './DataPicker.css'; // Custom styles

const CustonDatePicker = ({ onDateChange, minDate, maxDate, disabled, selectedDate }) => {
  const [startDate, setStartDate] = useState(selectedDate);

  useEffect(() => {
    if (selectedDate === null) {
      setStartDate(null);
    } else {
      setStartDate(selectedDate);
    }
  }, [selectedDate]);

  const handleDateChange = (date) => {
    setStartDate(date);
    onDateChange(date); // Call the callback function with the selected date
  };

  return (
    <div>
      <DatePicker
        selected={startDate}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        placeholderText="Select a date"
        minDate={minDate}
        maxDate={maxDate}
        dropdownMode="select"
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={15}
        disabled={disabled}
      />
    </div>
  );
};

export default CustonDatePicker;